import React from 'react'
import "../styles/loadingpage.css";

const LoadingPage = () => {
    return (
        <>
            <div className="loader">Loading...</div>
        </>
    )
}

export default LoadingPage